import { PaymentProcessingPage } from '~features/payment/ui/payment-processing/payment-processing-page';

export function PaymentProcessing() {
  return <PaymentProcessingPage />;
}
